import { forwardRef, useImperativeHandle } from 'react';
import { CurrentPlanProjectionsTable } from './CurrentPlanProjectionsTable';

import { Section } from '../Section/Section';
import { useCurrentPlanProjectionsPageQuery } from '../../services';
import { usePageSearchParams } from '../../hooks';

const CurrentPlanProjectionsFormContent = forwardRef((_properties, reference) => {
    const { entityId, scenarioId, ownerId } = usePageSearchParams();
    const {
        data: { currentPlanProjectionsPage },
    } = useCurrentPlanProjectionsPageQuery(entityId, scenarioId);
    const { projections } = currentPlanProjectionsPage ?? { projections: [] };
    useImperativeHandle(reference, () => ({
        validateData: () => {
            return projections.every(item => item.isCompleted);
        },
    }));

    return (
        <Section heading="Review and adjust selected plans">
            <CurrentPlanProjectionsTable
                entityId={entityId}
                scenarioId={scenarioId}
                ownerId={ownerId}
                currentPlanProjections={projections}
            />
        </Section>
    );
});
CurrentPlanProjectionsFormContent.displayName = 'CurrentPlanProjectionsFormContent';
export { CurrentPlanProjectionsFormContent };
